import {
   styled
  ,Card
} from 'external/material'
import {centerVertically, countBox} from 'utils/style'

const Course = styled(Card)(({theme}) => {
  return {
    "&.MuiCard-root" : {
      flexShrink: 0,
      display: 'flex',
      borderRadius: 15,
      minWidth: 300,
      maxWidth: 400,
      boxShadow: '1px 0px 140px 10px rgba(227,228,230,0.85)'
    },
    "& .MuiCardContent-root": {
      padding: 25,
      paddingBottom: 40,
      flexGrow: 1,
      flexShrink: 0,
      display: 'flex',
      flexDirection: 'column'
    },
    "& .teacher": {
      display: 'flex',
      "& .MuiAvatar-root": {
        marginLeft: -5
      },
      "& .teacherName": {
        ...centerVertically,
        marginLeft: 23,
        fontSize: '13pt',
        fontWeight: 600,
        color: '#606674',
        flexShrink: 0,
        flexGrow: 1
      }
    },
    "& .group": {
      marginTop: 20,
      display: 'flex',
      "& .groupIcon": {
        ...centerVertically,
        color: '#809ab3',
        fontSize: '28px'
      },
      "& .groupName": {
        ...centerVertically,
        minWidth: 200,
        maxWidth: 300,
        marginLeft: 25,
        fontSize: '11pt',
        color: '#606674',
        flexGrow: 1,
        flexShrink: 0
      }
    },
    "& .assignments": {
      marginTop: 10,
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
        "& .assignment": {
          padding: '12px 18px',
          textDecoration: 'none',
          marginTop: 15,
          display: 'flex',
        },
        "& .icon": {
          ...centerVertically,
          flexShrink: 0
        },
        "& .countTypeName": {
          ...centerVertically,
          color: '#3c455b',
          marginLeft: 15,
          flexGrow: 1,
        },
      ...countBox({marginLeft: 20, marginTop: 4, flexShrink: 0}),
      "& .activeAssignment": {
        backgroundColor: '#1994fe',
        borderRadius: 5,
        "& .countTypeName": {
          color: '#fff',
        },
        "& .count": {
          backgroundColor: '#fff',
          color: "#ff47cb"
        }
      }
    }
  }
})

export {Course as default}
